export enum AgreementStatus {
  OutForSignature = 'OUT_FOR_SIGNATURE',
  Signed = 'SIGNED',
  Cancelled = 'CANCELLED'
}